import { CheckListDetailsItemValuesInterface } from '@modals/check-list-details/interfaces/check-list-details-item-values.interface';
import { CheckListDetailsUpdateItemInterface } from '@modals/check-list-details/interfaces/check-list-details-update-item.interface';

/**
 * Builds a pending update payload for one toggled checklist row.
 *
 * @param itemName - checklist item name
 * @param itemValues - current row values including the new checked state
 * @param lastUpdatedBy - current member id
 * @param lastUpdatedByName - current member name
 */
export function buildCheckListDetailsUpdateItem(
  itemName: string,
  itemValues: CheckListDetailsItemValuesInterface,
  lastUpdatedBy: string,
  lastUpdatedByName: string,
): CheckListDetailsUpdateItemInterface {
  return {
    name: itemName,
    value: {
      ...itemValues,
      checkListItemName: itemName,
      lastUpdatedBy,
      lastUpdatedByName,
      lastUpdatedOn: null,
    },
  };
}
